import { STREAMING_PLATFORMS } from "../data";
import { useMediaQuery, breakpoints } from "../hooks/useMediaQuery";

export default function StreamingBar() {
  const isDesktop = useMediaQuery(breakpoints.md);

  return (
    <div
      style={{
        background: "var(--ink-2)",
        borderTop: "1px solid var(--border)",
        borderBottom: "1px solid var(--border)",
        padding: "12px 20px",
        display: "flex",
        alignItems: "center",
        gap: "20px",
        overflowX: "auto",
      }}
    >
      <span
        style={{
          fontFamily: "var(--font-display)",
          fontSize: "10px",
          letterSpacing: "3px",
          textTransform: "uppercase",
          color: "rgba(200,169,110,0.4)",
          flexShrink: 0,
          whiteSpace: "nowrap",
        }}
      >
        Stream On
      </span>
      <div
        style={{
          width: "1px",
          height: "14px",
          background: "var(--border)",
          flexShrink: 0,
        }}
      />
      <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
        {STREAMING_PLATFORMS.map((platform, i) => (
          <span
            key={platform.name}
            style={{ display: "flex", alignItems: "center", gap: "16px" }}
          >
            <a
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "10px",
                letterSpacing: "2px",
                textTransform: "uppercase",
                color: "rgba(242,236,224,0.3)",
                textDecoration: "none",
                transition: "color 0.2s",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLElement).style.color = "var(--gold)")
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLElement).style.color =
                  "rgba(242,236,224,0.3)")
              }
            >
              {platform.name}
            </a>
            {i < STREAMING_PLATFORMS.length - 1 && (
              <span
                style={{
                  width: "3px",
                  height: "3px",
                  borderRadius: "50%",
                  background: "rgba(200,169,110,0.2)",
                  flexShrink: 0,
                }}
              />
            )}
          </span>
        ))}
      </div>
      {isDesktop && (
        <div style={{ marginLeft: "auto", flexShrink: 0 }}>
          <span
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "10px",
              letterSpacing: "3px",
              color: "var(--gold)",
              opacity: 0.6,
              whiteSpace: "nowrap",
            }}
          >
            New mix dropping June 14
          </span>
        </div>
      )}
    </div>
  );
}
